import {computed} from "mobx";
import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {VenueDomainModel} from "../../../domain/full-game/models/venue/venue-domain-model";
import {MathUtils} from "../../../infrastructure/utils/math-utils";

export class VenueViewModel extends BaseViewModel {
  mathUtils: MathUtils;
  domainModel: VenueDomainModel;

  constructor(domainModel: VenueDomainModel, mathUtils: MathUtils) {
    super(domainModel);

    this.mathUtils = mathUtils;
  }

  @computed get shortName(): String {
    return this.domainModel.shortName;
  }

  @computed get formattedAttendance(): String {
    return this.domainModel.attendance && this.mathUtils.formatNumber(this.domainModel.attendance);
  }

  @computed get formattedCapacity(): String {
    return this.domainModel.capacity && this.mathUtils.formatNumber(this.domainModel.capacity);
  }

  @computed get googlePlaceId(): String {
    return this.domainModel.googlePlaceId;
  }
}
